import { createAction, props } from '@ngrx/store';
import { ViewColumnState } from '../states/view-col.states';
import { ViewColumn } from '../../../view-column';

export const viewColNext = createAction('[View Column] Next', props<{index: number}>());
export const viewColPrev = createAction('[View Column] Prev', props<{index: number}>());
export const viewColRvIndex = createAction('[View Column] Reverse Index', props<{index: number}>());
export const viewColFwIndex = createAction('[View Column] Forward Index', props<{index: number}>());
export const viewColUpdateInstance = createAction('[View Column] Update Instance', props<{index: number, localState: any}>());

export const viewColNextAndReset = createAction('[View Column] Next & Reset', props<{curIndex: number, nextIndex: number}>());

export const goToIndex = createAction('[View Column] Go To Index', props<{index: number}>());

export const resetIndex = createAction('[View Column] Reset Index', props<{index: number}>());

export const toggleColumn = createAction('[View Column] Toggle Column', props<{toggle: boolean}>());

export const setViewColState = createAction('[View Column] Set', props<{state: ViewColumnState}>());
export const viewColNextAndReset2Column = createAction('[View Column] Next & Reset 2 column', props<{curIndex: number, nextIndex1: number, nextIndex2: number}>());

export const updateViewColumnsLabels = createAction('[ViewCol] Update View Columns Labels', props<{ updatedCols: ViewColumn[] }>());
export const updateLeftDrawer = createAction('[Drawer] Update Left Drawer',props<{ leftDrawer: any }>());
export const updateRightDrawer = createAction('[Drawer] Update Right Drawer',props<{ rightDrawer: any }>());
export const updateBreadcrumbs = createAction('[ViewCol] Update Breadcrumbs',props<{ breadcrumbs: ViewColumn[] }>());
